import React from 'react';
import styles from '../InternshipForm.module.scss';

const Spinner = () => (
  <svg
    className={styles.spinner}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" stroke="#e0e9e5" strokeWidth="2" />
    <path
      d="M21 12a9 9 0 00-9-9"
      stroke="#008359"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Spinner;
